import { render, staticRenderFns } from "./DepartmentEmployeesList.vue?vue&type=template&id=13a63172&scoped=true"
import script from "./DepartmentEmployeesList.vue?vue&type=script&lang=js"
export * from "./DepartmentEmployeesList.vue?vue&type=script&lang=js"
import style0 from "./DepartmentEmployeesList.vue?vue&type=style&index=0&id=13a63172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a63172",
  null
  
)

export default component.exports